import { render, staticRenderFns } from "./ex-live-pro.vue?vue&type=template&id=7cef2936&scoped=true&"
import script from "./ex-live-pro.vue?vue&type=script&lang=js&"
export * from "./ex-live-pro.vue?vue&type=script&lang=js&"
import style0 from "./ex-live-pro.vue?vue&type=style&index=0&id=7cef2936&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef2936",
  null
  
)

export default component.exports